import { Outlet } from "react-router";

export function EntraRoute() {
  return <Outlet />;
}
